const NavigationMenuHorizontalFilled = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" {...props}>
    <g clip-path="url(#clip0_72486_124387)">
      <path
        d="M1.80017 7.625C2.69763 7.625 3.42517 6.89746 3.42517 6C3.42517 5.10254 2.69763 4.375 1.80017 4.375C0.902708 4.375 0.175171 5.10254 0.175171 6C0.175171 6.89746 0.902708 7.625 1.80017 7.625Z"
        fill="#FF5C3C"
        {...props}
      />
      <path
        d="M6.17517 7.625C7.07263 7.625 7.80017 6.89746 7.80017 6C7.80017 5.10254 7.07263 4.375 6.17517 4.375C5.27771 4.375 4.55017 5.10254 4.55017 6C4.55017 6.89746 5.27771 7.625 6.17517 7.625Z"
        fill="#FF5C3C"
        {...props}
      />
      <path
        d="M10.5502 7.625C11.4476 7.625 12.1752 6.89746 12.1752 6C12.1752 5.10254 11.4476 4.375 10.5502 4.375C9.65271 4.375 8.92517 5.10254 8.92517 6C8.92517 6.89746 9.65271 7.625 10.5502 7.625Z"
        fill="#FF5C3C"
        {...props}
      />
    </g>
    <defs>
      <clipPath id="clip0_72486_124387">
        <rect width="12" height="12" fill="white" transform="translate(0.175171)" />
      </clipPath>
    </defs>
  </svg>
);

export default NavigationMenuHorizontalFilled;
